import { FC, useContext } from 'react'
import { Form, Popover, Radio, Space, Typography } from 'antd'
import { EditableCellCtx } from '../../../../../components/editable-cell/editable-cell'
import { Windings } from '../../../../../types/api/shipment'
import { useSingleActivePopover } from '../../../../../hooks/use-single-active-popover'
import { windingDisplay } from '../../../../../types/api/shipment'

const SCHEMES = Object.values(Windings)
const ACTIVE_SHIPMENT_POPOVER_EVENT = 'shipment-popover-active'

// const schemeOptions = SCHEMES.map(item => ({
//     value: item,
//     label: (
//         <img
//             src={`/images/windings/${item}.png`}
//             alt={`Схема ${item}`}
//             style={{ height: 28, display: 'block' }}
//         />
//     ),
// }))

const schemeOptions = SCHEMES.map(item => ({
    value: item,
    label: (
        <Space size={6}>
            <img
                src={`/images/windings/${item}.png`}
                alt={`Схема ${windingDisplay[item]}`}
                style={{ height: 28, display: 'block' }}
            />
            <Typography.Text>{windingDisplay[item]}</Typography.Text>
        </Space>
    ),
}))

const ShipmentWindingSchemesPopover: FC = () => {
    const ctx = useContext(EditableCellCtx)
    const { open, handleOpenChange } = useSingleActivePopover({
        eventName: ACTIVE_SHIPMENT_POPOVER_EVENT,
        onClose: ctx.onBlur,
    })

    return (
        <Popover
            placement='bottomLeft'
            arrow={false}
            mouseLeaveDelay={0.2}
            open={open}
            onOpenChange={handleOpenChange}
            content={
                <div style={{ minWidth: 280 }}>
                    <Typography.Text type='secondary' style={{ display: 'block', marginBottom: 8 }}>
                        Схема намотки
                    </Typography.Text>
                    <Space direction='vertical' size={12} style={{ width: '100%' }}>
                        <Form.Item name='windingSchemeFace' label='Лицо' style={{ marginBottom: 0 }}>
                            <Radio.Group style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {schemeOptions.map(opt => (
                                    <Radio key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item name='windingSchemeTurn' label='Оборот' style={{ marginBottom: 0 }}>
                            <Radio.Group style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {schemeOptions.map(opt => (
                                    <Radio key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Form.Item>
                    </Space>
                </div>
            }
        >
            <div style={{ height: '100%', width: 1 }} />
        </Popover>
    )
}

export default ShipmentWindingSchemesPopover
